import AccountingListingMapping from 'vcomponents/listing/apiListing/mapping/AccountingListingMapping.js';

let MiscAccountingListingMapping = _.cloneDeep(AccountingListingMapping);

MiscAccountingListingMapping['columns'].forEach(column => {
    //hide some columns by default for misc journal
    if (["document.subject", "auxiliary_code", 'document.number'].includes(column.name)) {
        column.configuration.display = false;
    }
});

export default MiscAccountingListingMapping